
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ideje",
      function () {
        return require("private-next-pages/ideje/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ideje"])
      });
    }
  